<template>
  <div class="xtzb-box">
    <!-- 小窗列表 -->
    <div class="xtzb-list" v-if="localData.isOpenHelp == 1">
	  <!-- 主播视角：只有把助播设为主画面（mainScreenUser存在且不是主播自己）时，主播才退到小窗 -->
	  <div class="xtzb-zhubo" v-if="isHost && mainScreenUser && !isSelfMainScreen">
		  <xietongzhubo ref="hostPusher" 
		  	:main-screen-data="hostUser ? hostUser.info : null" 
		  	:live-id="liveId" 
		  	:live-type="localData && localData.chatRoomDetails ? localData.chatRoomDetails.liveType : 1" 
		  	:host-pull-url="hostUser ? hostUser.pullUrl : ''" />
	  </div>
	  <!-- 普通观众视角：只要有任何助播被设为主画面，主播就退到小窗显示 -->
	  <div class="xtzb-zhubo" v-if="!isHost && hostUser && mainScreenUser">
		  <zhuboplayer :pull-url="hostUser.pullUrl" :user-info="hostUser.info" />
	  </div>
      <div 
        class="xtzb-item" 
        v-for="(item, index) in (isHost ? localData.helpLiveUserList : helpLiveUserList)" 
        :key="index" 
        :class="{ 'xtzb-item-active': activeIndex === index }" 
        v-show="item.isMainScreen !== 1"
      >
        <div class="xtzb-item-bg" :style="{ backgroundImage: 'url(' + (item.userInfo && item.userInfo.headPortrait) + ')' }">
		  </div>
        <template v-if="item.cameraStatus !== 0"> 
	 	 	 <!-- TCPlayer 官方 poster 参数自动处理封面 -->
	 	 	 <div 
	 	 	 	  :id="'player-' + item.userId" 
	 	 	 	  class="xtzb-item-player xtzb-item-video"
	 	 	 	  ></div>
	 	  </template>
		<div v-if="item.cameraStatus === 0" class="xtzb-item-cover"> 
 	 	 	 	 <div class="xtzb-item-cover-box"> 
 	 	 	 	 	 <img class="xtzb-item-cover-img" :src="item.userInfo && item.userInfo.headPortrait" alt="" /> 
 	 	 	 	 </div> 
 	 	 	 </div>
		<img 
			v-if="item.isPermitMicrophone == 1" 
			class="xtzb-item-vioce" 
			src="../../assets/image/zbj_lb_jy_2@2x.png" 
			alt=""
			@click.stop="toggleMicrophone(item, index)"
		/>
		<img 
			v-if="item.isPermitMicrophone == 0" 
			class="xtzb-item-vioce" 
			src="../../assets/image/zbj_lb_jy_3@2x.png" 
			alt=""
			@click.stop="toggleMicrophone(item, index)"
		/>
		<div class="xtzb-item-user">
		  <span class="xtzb-item-user-sort">{{(mainScreenUser && isHost) || (!isHost && isJoinedHelpLive && isSelfMainScreen && hostUser) ? index + 2 : index + 1}}</span>
		  <span class="xtzb-item-user-name">{{item.userInfo.nickName}}</span>
		</div>
      </div>
    </div>
    <div class="xtzb-btn" @click="handleOpenList" v-if="localData.isOpenHelp == 1 && isHost">
      <span class="xtzb-btn-text">{{$t('all.xietongzhibo')}} {{localData?localData.helpLiveUserList.length:0}}/{{localData?localData.peopleNumber:0}}</span>
    </div>
	<!-- <div class="xtzb-btn" @click="handleJoinLive" v-if="localData.isOpenHelp == 1 && !isHost && !isJoinedHelpLive">
	  <span class="xtzb-btn-text">{{ $t('all.jiaruzhibo')}} {{localData?localData.helpLiveUserList.length:0}}/{{localData?localData.peopleNumber:0}}</span>
	</div>
	<div class="xtzb-btn" @click="handleExitHelp" v-if="localData.isOpenHelp == 1 && !isHost && isJoinedHelpLive">
	  <span class="xtzb-btn-text">退出直播 {{localData?localData.helpLiveUserList.length:0}}/{{localData?localData.peopleNumber:0}}</span>
	</div> -->

    <!-- 协同直播管理面板 -->
    <div class="xtzb-panel-overlay" v-if="showPanel" @click="showPanel = false"></div>
    <div class="xtzb-panel" v-if="showPanel" @click.stop>
      <div class="xtzb-panel-header">
        <span class="xtzb-panel-title">{{$t('all.xietongzhibo')}}</span>
        <span class="xtzb-panel-count">{{localData?localData.helpLiveUserList.length:0}}/{{localData?localData.peopleNumber:0}}</span>
      </div>
      <div class="xtzb-panel-users">
        <template v-if="localData.helpLiveUserList && localData.helpLiveUserList.length > 0">
          <div class="xtzb-panel-user" :class="{ 'xtzb-panel-user-active': activeIndex === index }"  v-for="(item, index) in localData.helpLiveUserList" :key="index" @click="handleSelect(index)">
            <img class="xtzb-panel-user-img" :src="item.userInfo.headPortrait" alt="" />
            <span class="xtzb-panel-user-name">{{item.userInfo.nickName}}</span>
            <span class="xtzb-panel-user-status" :class="item.isPermitCamera === 1 ? 'xtzb-status-live' : (item.isPermitMicrophone === 1 ? 'xtzb-status-live' : 'xtzb-status-wait')">
              {{item.isPermitCamera === 1 ? $t('all.shipin') : (item.isPermitMicrophone === 1 ? $t('all.kaimai') : $t('all.weikaiqi'))}}
            </span>
          </div>
        </template>
        <div v-else class="xtzb-panel-empty">
          {{$t('all.zanwushuju')}}
        </div>
      </div>
      <div class="xtzb-panel-actions">
        <div class="xtzb-panel-action-btn" @click="handleInvite">{{$t('all.yaoqingjinbo')}}</div>
        <div class="xtzb-panel-action-btn" @click="handleControl">{{$t('all.tongyikongmai')}}</div>
      </div>
      <div class="xtzb-panel-kick-btn" @click="handleKick">{{$t('all.tichuzhubozb')}}</div>
    </div>

    <!-- 邀请助播弹框 -->
    <div class="xtzb-invite-overlay" v-if="showInvite" @click="showInvite = false"></div>
    <div class="xtzb-invite-modal" v-if="showInvite" @click.stop>
      <div class="xtzb-invite-title">{{$t('all.yaoqingjinbo')}}</div>
      <div class="xtzb-invite-item" @click="handleOpenLimit">
        <span class="xtzb-invite-item-label">{{$t('all.zhuborenshushangxian')}}</span>
        <div class="xtzb-invite-item-right">
          <span class="xtzb-invite-item-value">{{maxCohost}}{{$t('all.ren')}}</span>
		  <img class="xtzb-invite-item-arrow" src="../../assets/image/jinru_14@2x.png" alt=""/>
        </div>
      </div>
      <div class="xtzb-invite-item">
        <span class="xtzb-invite-item-label">{{$t('all.keyongshiduan')}}</span>
        <div class="xtzb-invite-item-right">
          <span class="xtzb-invite-item-value">{{$t('all.tongzhibojinyao')}}</span>
          <img class="xtzb-invite-item-arrow" src="../../assets/image/jinru_14@2x.png" alt=""/>
        </div>
      </div>
      <div class="xtzb-invite-section-title">{{$t('all.zhuboquanxian')}}</div>
      <div class="xtzb-invite-item" @click="zbForm.isPermitSpeech = zbForm.isPermitSpeech === 1 ? 0 : 1">
        <span class="xtzb-invite-item-label">{{$t('all.yunxufayan')}}</span>
        <div class="xtzb-invite-item-right">
          <span :class="zbForm.isPermitSpeech === 1 ? 'xtzb-control-status-on' : 'xtzb-control-status-off'">{{zbForm.isPermitSpeech === 1 ? $t('all.yikaiqi') : $t('all.guanbi')}}</span>
          <img class="xtzb-invite-item-arrow" src="../../assets/image/jinru_14@2x.png" alt=""/>
        </div>
      </div>
      <div class="xtzb-invite-item" @click="zbForm.isPermitMicrophone = zbForm.isPermitMicrophone === 1 ? 0 : 1">
        <span class="xtzb-invite-item-label">{{$t('all.yunxukamai')}}</span>
        <div class="xtzb-invite-item-right">
          <span :class="zbForm.isPermitMicrophone === 1 ? 'xtzb-control-status-on' : 'xtzb-control-status-off'">{{zbForm.isPermitMicrophone === 1 ? $t('all.yikaiqi') : $t('all.guanbi')}}</span>
          <img class="xtzb-invite-item-arrow" src="../../assets/image/jinru_14@2x.png" alt=""/>
        </div>
      </div>
      <div class="xtzb-invite-item" @click="zbForm.isPermitCamera = zbForm.isPermitCamera === 1 ? 0 : 1">
        <span class="xtzb-invite-item-label">{{$t('all.yunxukashipin')}}</span>
        <div class="xtzb-invite-item-right">
          <span :class="zbForm.isPermitCamera === 1 ? 'xtzb-control-status-on' : 'xtzb-control-status-off'">{{zbForm.isPermitCamera === 1 ? $t('all.yikaiqi') : $t('all.guanbi')}}</span>
          <img class="xtzb-invite-item-arrow" src="../../assets/image/jinru_14@2x.png" alt=""/>
        </div>
      </div>
      <div class="xtzb-invite-btn" @click="handleGenerateKey">{{$t('all.shengchengyaoqingjinyao')}}</div>

      <!-- 助播人数上限面板 -->
      <div class="xtzb-limit-panel" v-if="showLimitPanel">
        <div class="xtzb-limit-title">{{$t('all.xietongzhiborenshu')}}</div>
        <div class="xtzb-limit-options">
          <div 
            :class="tempMaxCohost === item ? 'xtzb-limit-option-active' : 'xtzb-limit-option'" 
            v-for="item in limitOptions" 
            :key="item"
            @click="tempMaxCohost = item"
          >{{item}}{{$t('all.ren')}}</div>
        </div>
        <div class="xtzb-limit-info">
          <div class="xtzb-limit-info-title">{{$t('all.dangqianzhibo')}}</div>
          <!-- <div class="xtzb-limit-info-num"><span class="xtzb-limit-info-big">{{list.length}}</span>/{{tempMaxCohost}}</div>
          <div class="xtzb-limit-info-desc">{{$t('all.kenenghaiyaoqing')}} {{tempMaxCohost - list.length}} {{$t('all.weizhibo')}}</div> -->
		  <div class="xtzb-limit-info-num"><span class="xtzb-limit-info-big">0</span>/{{tempMaxCohost}}</div>
		  <div class="xtzb-limit-info-desc">{{$t('all.kenenghaiyaoqing')}} {{tempMaxCohost}} {{$t('all.weizhibo')}}</div>
        </div>
        <div class="xtzb-limit-save" @click="handleSaveLimit">{{$t('all.baocunshangxian')}}</div>
      </div>
    </div>

    <!-- 分享邀请弹框 -->
    <div class="xtzb-invite-overlay" v-if="showShareInvite" @click="showShareInvite = false"></div>
    <div class="xtzb-share-modal" v-if="showShareInvite" @click.stop>
      <div class="xtzb-share-title">{{$t('all.fenxiangyaoqing')}}</div>
      <div class="xtzb-share-qrcode">
        <canvas ref="qrcodeCanvas"></canvas>
      </div>
      <div class="xtzb-share-item">
        <span class="xtzb-share-item-label">{{$t('all.yaoqinglianjie')}}</span>
        <span class="xtzb-share-item-value">{{liveConfig.shareUrl}}</span>
      </div>
      <div class="xtzb-share-item">
        <span class="xtzb-share-item-label">{{$t('all.zhibojinyao')}}</span>
        <span class="xtzb-share-item-value">{{liveConfig.startKey}}</span>
      </div>
      <div class="xtzb-share-subtitle">{{$t('all.fenxiangfangshi')}}</div>
      <div class="xtzb-share-actions">
        <div class="xtzb-share-action-btn xtzb-share-action-gradient" @click="handleCopyLink">{{$t('all.fuzhilianjie')}}</div>
        <div class="xtzb-share-action-btn" @click="handleSaveQr">{{$t('all.baocunerweima')}}</div>
      </div>
      <!-- <div class="xtzb-share-big-btn" @click="handleCopyInviteLink">{{$t('all.fuzhiyaoqinglianjie')}}</div> -->
    </div>
    <!-- 统一控麦弹框 -->
    <div class="xtzb-invite-overlay" v-if="showControlModal" @click="showControlModal = false"></div>
    <div class="xtzb-control-modal" v-if="showControlModal" @click.stop>
      <div class="xtzb-control-title">{{$t('all.tongyikongmai')}}</div>
      <div class="xtzb-control-section">{{$t('all.quanjukongzhi')}}</div>
      <div class="xtzb-control-item" @click="controlForm.isPermitSpeech = controlForm.isPermitSpeech === 1 ? 0 : 1">
        <span class="xtzb-control-item-label">{{$t('all.yunxufayan')}}</span>
        <div class="xtzb-control-item-right">
          <span :class="controlForm.isPermitSpeech === 1 ? 'xtzb-control-status-on' : 'xtzb-control-status-off'">{{controlForm.isPermitSpeech === 1 ? $t('all.yikaiqi') : $t('all.guanbi')}}</span>
          <img class="xtzb-invite-item-arrow" src="../../assets/image/jinru_14@2x.png" alt=""/>
        </div>
      </div>
      <div class="xtzb-control-item" @click="controlForm.isPermitMicrophone = controlForm.isPermitMicrophone === 1 ? 0 : 1">
        <span class="xtzb-control-item-label">{{$t('all.yunxuzhubokaimai')}}</span>
        <div class="xtzb-control-item-right">
          <span :class="controlForm.isPermitMicrophone === 1 ? 'xtzb-control-status-on' : 'xtzb-control-status-off'">{{controlForm.isPermitMicrophone === 1 ? $t('all.yikaiqi') : $t('all.guanbi')}}</span>
          <img class="xtzb-invite-item-arrow" src="../../assets/image/jinru_14@2x.png" alt=""/>
        </div>
      </div>
      <div class="xtzb-control-item" @click="controlForm.isPermitCamera = controlForm.isPermitCamera === 1 ? 0 : 1">
        <span class="xtzb-control-item-label">{{$t('all.yunxuzhubokaishipin')}}</span>
        <div class="xtzb-control-item-right">
          <span :class="controlForm.isPermitCamera === 1 ? 'xtzb-control-status-on' : 'xtzb-control-status-off'">{{controlForm.isPermitCamera === 1 ? $t('all.yikaiqi') : $t('all.guanbi')}}</span>
          <img class="xtzb-invite-item-arrow" src="../../assets/image/jinru_14@2x.png" alt=""/>
        </div>
      </div>
      <!-- <div class="xtzb-control-section">{{$t('all.fenxiangfangshi')}}</div>
      <div class="xtzb-control-actions">
        <div :class="controlForm.muteAll ? 'xtzb-control-action-btn xtzb-control-action-gradient' : 'xtzb-control-action-btn'" @click="controlForm.muteAll = true">{{$t('all.quantijingyin')}}</div>
        <div :class="!controlForm.muteAll ? 'xtzb-control-action-btn xtzb-control-action-gradient' : 'xtzb-control-action-btn'" @click="controlForm.muteAll = false">{{$t('all.huifukaimai')}}</div>
      </div>
      <div class="xtzb-control-actions">
        <div :class="!controlForm.allowVideo ? 'xtzb-control-action-btn xtzb-control-action-gradient' : 'xtzb-control-action-btn'" @click="controlForm.allowVideo = false">{{$t('all.guanbishipin')}}</div>
        <div :class="controlForm.allowVideo ? 'xtzb-control-action-btn xtzb-control-action-gradient' : 'xtzb-control-action-btn'" @click="controlForm.allowVideo = true">{{$t('all.yunxushipin')}}</div>
      </div> -->
      <div class="xtzb-control-apply" @click="handleApplyControl">{{$t('all.yingyongshezhi')}}</div>
    </div>

    <!-- 助播列表弹框 -->
    <div class="xtzb-invite-overlay" v-if="showCohostList" @click="showCohostList = false"></div>
    <div class="xtzb-cohost-modal" v-if="showCohostList" @click.stop>
      <div class="xtzb-cohost-title">{{$t('all.zhubo')}}</div>
      <div class="xtzb-cohost-list">
        <div class="xtzb-cohost-item" v-for="(item, index) in helpUserList" :key="index">
          <img class="xtzb-cohost-item-avatar" :src="item.userInfo.headPortrait" alt="" />
          <div class="xtzb-cohost-item-info">
            <span class="xtzb-cohost-item-name">{{item.userInfo.nickName}}</span>
            <span class="xtzb-cohost-item-box">
				<span class="xtzb-cohost-item-status" :class="item.isPermitCamera === 1 ? 'xtzb-cohost-status-live' : 'xtzb-cohost-status-wait'">
				  {{item.isPermitCamera === 1 ? $t('all.shipinkaiqi') : $t('all.shipinguanbi')}}
				</span>
				<span class="xtzb-cohost-item-status xtzb-cohost-status-live">/</span>
				<span class="xtzb-cohost-item-status" :class="item.isPermitMicrophone === 1 ? 'xtzb-cohost-status-live' : 'xtzb-cohost-status-wait'">
				  {{item.isPermitMicrophone === 1 ? $t('all.kaimai') : $t('all.bimai')}}
				</span>
				<span class="xtzb-cohost-item-status xtzb-cohost-status-live">/</span>
				<span class="xtzb-cohost-item-status" :class="item.isPermitSpeech === 1 ? 'xtzb-cohost-status-live' : 'xtzb-cohost-status-wait'">
				  {{item.isPermitSpeech === 1 ? $t('all.yunxufayan') : $t('all.jinzhifayan')}}
				</span>
			</span>
          </div>
          <div class="xtzb-cohost-item-manage" @click="handleManageCohost(item, index)">{{$t('all.guanli')}}</div>
        </div>
      </div>
      <!-- 管理面板 -->
      <div class="xtzb-manage-panel" v-if="showManagePanel">
        <div class="xtzb-manage-close" @click="showManagePanel = false">✕</div>
        <div class="xtzb-manage-user">
          <img class="xtzb-manage-user-avatar" :src="managingCohost.userInfo.headPortrait" alt="" />
          <div class="xtzb-manage-user-info">
            <span class="xtzb-manage-user-name">{{managingCohost.userInfo.nickName}}</span>
            <span class="xtzb-manage-user-id">{{$t('all.zhuboxiwei')}} {{activeIndex + 1}}</span>
          </div>
          <span class="xtzb-manage-user-tag">{{$t('all.yijinru')}}</span>
        </div>
        <div class="xtzb-manage-section-title">{{$t('all.zhuboquanxian')}}</div>
        <div class="xtzb-manage-perm-item" @click="handleUpdatePerm('isPermitSpeech')">
          <span class="xtzb-manage-perm-label">{{$t('all.yunxufayan')}}</span>
          <div class="xtzb-manage-perm-right">
            <span class="xtzb-manage-perm-status" :class="{'xtzb-manage-perm-status-on': managingCohost.isPermitSpeech === 1}">{{managingCohost.isPermitSpeech === 1 ? $t('all.yikaiqi') : $t('all.guanbi')}}</span>
            <img class="xtzb-invite-item-arrow" src="../../assets/image/jinru_14@2x.png" alt=""/>
          </div>
        </div>
        <div class="xtzb-manage-perm-item" @click="handleUpdatePerm('isPermitMicrophone')">
          <span class="xtzb-manage-perm-label">{{$t('all.maikefeng')}}</span>
          <div class="xtzb-manage-perm-right">
            <span class="xtzb-manage-perm-status" :class="{'xtzb-manage-perm-status-on': managingCohost.isPermitMicrophone === 1}">{{managingCohost.isPermitMicrophone === 1 ? $t('all.yikaiqi') : $t('all.guanbi')}}</span>
            <img class="xtzb-invite-item-arrow" src="../../assets/image/jinru_14@2x.png" alt=""/>
          </div>
        </div>
        <div class="xtzb-manage-perm-item" @click="handleUpdatePerm('isPermitCamera')">
          <span class="xtzb-manage-perm-label">{{$t('all.shexiangtou')}}</span>
          <div class="xtzb-manage-perm-right">
            <span class="xtzb-manage-perm-status" :class="{'xtzb-manage-perm-status-on': managingCohost.isPermitCamera === 1}">{{managingCohost.isPermitCamera === 1 ? $t('all.yikaiqi') : $t('all.guanbi')}}</span>
            <img class="xtzb-invite-item-arrow" src="../../assets/image/jinru_14@2x.png" alt=""/>
          </div>
        </div>
        <div class="xtzb-manage-btn" @click="handleSetMain">{{managingCohost.isMainScreen === 1 ? $t('all.quxiaozhuyemian') : $t('all.sheweizhuyemian')}}</div>
        <div class="xtzb-manage-kick-btn" @click="handleKickCohost">{{$t('all.tichuzhibo')}}</div>
        <span class="xtzb-manage-tip">{{$t('all.tichuhoubukejinru')}}</span>
      </div>
    </div>

    <!-- 加入协同直播弹框 -->
    <div class="xtzb-invite-overlay" v-if="showJoinLive" @click="showJoinLive = false"></div>
    <div class="xtzb-join-modal" v-if="showJoinLive" @click.stop>
      <div class="xtzb-join-title">{{$t('all.jiaruxietongzhibo')}}</div>
      <div class="xtzb-join-item" v-if="helpKey">
        <span class="xtzb-join-item-label">{{$t('all.zhubo')}}</span>
        <span class="xtzb-join-item-value">{{helpKeyInfo?helpKeyInfo.liveName:''}}</span>
      </div>
	  <div class="xtzb-join-item" v-if="helpKey">
	    <span class="xtzb-join-item-label">{{$t('all.youxiaoqi')}}</span>
	    <span class="xtzb-join-item-value">{{helpKeyInfo?helpKeyInfo.keyStartTime + '-' + helpKeyInfo.keyEndTime:''}}</span>
	  </div>
      <div class="xtzb-join-item">
        <span class="xtzb-join-item-label">{{$t('all.zhubojinyao')}}</span>
        <input class="xtzb-join-input" v-model="helpKeyInfo.helpKey" :placeholder="$t('all.qingshuruzhubojinyao')" />
      </div>
      <div class="xtzb-join-btn" @click="handleSubmitJoin">{{$t('all.jiaru')}}</div>
    </div>
  </div>
</template>

<script>
import { getChatRoomDetails,sendRefreshMsg } from "@/api/zhibo";
import { createHelpLive, getAppHelpLiveConfig,kickOutHelp,
updateHelpLiveConfig,getHelpUserInfo,getHelpUserList,updateHelpLiveUser,
 getHelpKeyInfo,joinHelpLive,exitHelp } from "@/api/zhubo";
import QRCode from 'qrcode';
import xietongzhubo from "../xietongzhubo/xietongzhubo.vue";
import zhuboplayer from "../zhuboplayer/zhuboplayer.vue";

export default {
  name: 'XietongZhibo',
  components: {
    xietongzhubo,
    zhuboplayer
  },
  props: {
    isHost: {
      type: Boolean,
      default: false
    },
    roomData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
	  localData: this.roomData || null,
	  helpLiveUserList:[],
      activeIndex: 0,
      showPanel: false,
      showInvite: false,
      showLimitPanel: false,
      showShareInvite: false,
      showCohostList: false,
      showManagePanel: false,
      showControlModal: false,
      showJoinLive: false,
      joinKey: '',
      playerCovers: {},  // 每个播放器是否显示头像封面（无画面时 true，有画面时 false）
      controlForm: {
        helpLiveConfigId: null,
        isPermitCamera: 1,
        isPermitMicrophone: 1,
        isPermitSpeech: 1
      },
      managingCohost: {},
      maxCohost: 12,
      tempMaxCohost: 12,
      limitOptions: [8, 12, 16],
	  zbForm:{
		isPermitCamera:1,
		isPermitMicrophone:1,
		isPermitSpeech:1,
		isSynLiveTime:1,
		keyEndTime:'',
		keyStartTime:'',
		liveId:this.$route.query.liveId,
		peopleNumber:12,
	  },
	  liveConfig:'',
	  liveId:this.$route.query.liveId,
	  players: {},
	  selfPusher: null,
	  licenseUrl: 'https://1383640469.sdk-license.com/license/v2/1383640469_1/v_cube.license',
	  helpUserList:[],
	  helpKeyInfo:{helpKey:''},
	  helpKey:this.$route.query.helpKey,
	  isAgentJoin:true
    };
  },
  computed: {
    mainScreenUser() {
      if (this.localData && this.localData.helpLiveUserList && this.localData.helpLiveUserList.length > 0) {
        return this.localData.helpLiveUserList.find(item => item.isMainScreen === 1);
      }
      return null;
    },
	isJoinedHelpLive() {
	    if (!this.$store.state.userId) return false;
	    const currentUserId = JSON.parse(this.$store.state.userId);
	    if (this.localData && this.localData.helpLiveUserList) {
	      return this.localData.helpLiveUserList.some(item => 
	        item.userInfo && item.userInfo.userId === currentUserId
	      );
	    }
	    if (this.helpUserList.length > 0) {
	      return this.helpUserList.some(item => 
	        item.userInfo && item.userInfo.userId === currentUserId
	      );
	    }
	    return false;
	  },
	hostUser() {
	    if (this.localData && this.localData.chatRoomDetails) {
	      return {
	        pullUrl: this.localData.chatRoomDetails.pullUrl,
	        info: this.localData.chatRoomDetails
	      };
	    }
	    return null;
	  },
	isSelfMainScreen() {
	    if (!this.$store.state.userId || !this.mainScreenUser) return false;
	    const currentUserId = JSON.parse(this.$store.state.userId);
	    const mainUserId = (this.mainScreenUser.userInfo && this.mainScreenUser.userInfo.userId) || this.mainScreenUser.userId;
	    return mainUserId == currentUserId;
	  }
  },
  watch: {
    helpLiveUserList: {
      handler(newList, oldList) {
        console.log('helpLiveUserList变化:', newList ? newList.length : 0, '->', oldList ? oldList.length : 0);
      },
      deep: true
    },
    'localData.helpLiveUserList': {
      handler(newList, oldList) {
        console.log('localData.helpLiveUserList变化:', newList ? newList.length : 0, '->', oldList ? oldList.length : 0);
      },
      deep: true
    }
  },
  mounted() {
  	this.getChatRoomDetails()
	
  },
  beforeDestroy() {
    // 清理重试定时器
    if (this._retryTimers) {
      Object.values(this._retryTimers).forEach(timer => clearInterval(timer));
      this._retryTimers = {};
    }
    // 清理播放器资源
    this.destroyPlayers()
    // 销毁自己的推流
    if (this.selfPusher) {
      try {
        this.selfPusher.stopCamera();
        this.selfPusher.stopMicrophone();
        this.selfPusher.stopPush();
        this.selfPusher.destroy();
      } catch (error) {
        console.error('销毁推流失败:', error);
      }
      this.selfPusher = null;
    }
  },
  methods: {
	//获取主播自己的推流组件（助播占据主画面时，主播推流器在小窗的 xietongzhubo 里）
	getHostPusherComponent(){
		return this.$refs.hostPusher || null;
	},
	//直播间详情
	async getChatRoomDetails(){
		const res = await getChatRoomDetails({liveId:this.liveId})
		this.localData = res.data
		if(this.isHost){
			this.getAppHelpLiveConfig()
		}
		if(this.localData.isOpenHelp == 1){
			if(!this.isHost && this.localData.helpLiveUserList){
				this.helpLiveUserList = this.localData.helpLiveUserList
				if(this.helpKey){
					const currentUserId = this.$store.state.userId ? JSON.parse(this.$store.state.userId) : null;
					const isAlreadyJoined = this.helpLiveUserList.some(item => 
						item.userInfo && item.userInfo.userId === currentUserId
					);
					if (!isAlreadyJoined && this.isAgentJoin) {
						this.handleJoinLive()
					}
				}
			}
			this.$nextTick(() => {
				// 增量同步播放器：没变的流保持播放，避免销毁重建导致画面闪烁
				this.syncPlayers()
			})
		}
	},
	initPlayers(){
		const userList = this.isHost ? this.localData.helpLiveUserList : this.helpLiveUserList;
		if (!userList || userList.length === 0) {
			console.warn('助播列表为空');
			return;
		}
		
		console.log('初始化播放器列表，用户列表:', userList.length);
		
		const currentUserId = this.$store.state.userId ? JSON.parse(this.$store.state.userId) : null;
		userList.forEach(item => {
			console.log('处理用户:', item.userId, 'cameraStatus:', item.cameraStatus, 'isMainScreen:', item.isMainScreen, 'pullUrl:', !!item.pullUrl);
			
			if (currentUserId && item.userId == currentUserId) {
				if (item.cameraStatus !== 0) {
					this.initSelfPusher(item);
				} else {
					if (this.selfPusher) {
						try {
							this.selfPusher.stopCamera();
						} catch (e) {
							console.warn('停止摄像头失败:', e);
						}
					}
				}
			} else if (item.pullUrl && item.isMainScreen !== 1 && item.cameraStatus !== 0) {
				this.initPlayer(item);
			}
		})
	},
	// 增量同步播放器：self 也统一用 TCPlayer 拉自己的 pullUrl（和其他助播一样）
	syncPlayers(){
		const userList = this.isHost
			? (this.localData && this.localData.helpLiveUserList)
			: this.helpLiveUserList;
		const currentUserId = this.$store.state.userId ? JSON.parse(this.$store.state.userId) : null;
		const keepUserIds = new Set();

		(userList || []).forEach(item => {
			// 自己：推流 + TCPlayer 拉自己的 pullUrl 显示小窗画面
			const isSelf = currentUserId && item.userId == currentUserId;
			if (isSelf) {
				if (item.cameraStatus !== 0) {
					this.initSelfPusher(item);  // 只负责推流（startCamera/startPush）
				} else if (this.selfPusher && !this._selfCameraStopped) {
					this._selfCameraStopped = true;
					try { this.selfPusher.stopCamera(); } catch (e) { console.warn('停止摄像头失败:', e); }
				}
				// self 也和其他用户一样走 initPlayer：TCPlayer 拉自己的 pullUrl
				// 升主画面时模板 v-if 会隐藏小窗容器，initPlayer 找不到容器会跳过
			}
			// 主画面用户、无拉流地址、摄像头关闭的不在小窗播放
			if (item.isMainScreen === 1 || !item.pullUrl || item.cameraStatus === 0) return;
			keepUserIds.add(String(item.userId));
			this.initPlayer(item);
		});

		// 销毁已不在小窗列表的播放器（用户离开、关摄像头、升为主画面）
		Object.keys(this.players).forEach(uid => {
			if (!keepUserIds.has(String(uid))) {
				this.destroySinglePlayer(uid);
			}
		});
	},
	// 判断是否是自己
	isSelfCohost(item) {
		const currentUserId = this.$store.state.userId ? JSON.parse(this.$store.state.userId) : null;
		return currentUserId && item.userId == currentUserId;
	},
	// 初始化自己的推流（协同助播）：只负责推流（startCamera/startPush）
	// 渲染统一由 initPlayer（TCPlayer 拉 pullUrl）负责，不再用 setRenderView 绑定任何容器
	async initSelfPusher(item) {
		// self 被设为主画面或在小窗：推流本来就在跑，不需要重建
		if (this.selfPusher) {
			if (this._selfCameraStopped) {
				try {
					await this.selfPusher.startCamera();
					this._selfCameraStopped = false;
					console.log('协同助播摄像头已重新启动');
				} catch (e) { console.warn('重新启动摄像头失败:', e); }
			}
			return;
		}
		this.selfPusher = new TXLivePusher();
		this.selfPusher.setVideoQuality('720p');
		this.selfPusher.setAudioQuality('standard');
		this.selfPusher.setProperty('setVideoFPS', 25);
		
		this.selfPusher.setObserver({
			onPushStatusUpdate: (code, message) => {
				console.log('推流状态更新:', code, message);
				if (code === 1001) {
					this.isPushing = false;
				} else if (code === 1002) {
					this.isPushing = true;
					console.log('推流真正成功了');
				} else if (code === -1307) {
					this.isPushing = false;
					console.error('推流连接断开');
				}
				if (code == 2) {
					this.sendRefreshMsg();
				}
			},
			onPushError: (code, message) => {
				console.error('推流错误:', code, message);
				this.isPushing = false;
			}
		});
		
		try {
			await this.selfPusher.startCamera();
			await this.selfPusher.startMicrophone();
			this._selfCameraStopped = false;
			console.log('协同助播摄像头和麦克风启动成功');
			if (item.pushUrl) {
				const webrtcUrl = item.pushUrl.replace(/^rtmp:\/\//, 'webrtc://');
				await this.selfPusher.startPush(webrtcUrl);
				console.log('协同助播推流成功');
			}
		} catch (error) {
			console.error('协同助播推流失败:', error);
		}
	},
	async sendRefreshMsg(){
	  const res = await sendRefreshMsg({liveId:this.liveId})
	},
	//初始化单个播放器
	initPlayer(item){
		const playerId = 'player-' + item.userId
		const videoContainer = document.getElementById(playerId)
		if (!videoContainer) {
			console.warn('播放器容器不存在:', playerId);
			return
		}
		
		// 如果正在重试中，跳过
		if (this['_retrying_' + item.userId]) {
			console.log('助播', item.userId, '正在重连中，跳过初始化');
			return;
		}
		
		if (this.players[item.userId]) {
			const existingPlayer = this.players[item.userId];
			const currentSrc = typeof existingPlayer.currentSrc === 'function' ? existingPlayer.currentSrc() : '';
			// 防御：检查 TCPlayer 绑定的 video 元素是否还在 DOM 里
			const boundVideo = videoContainer.querySelector('video');
			if (!boundVideo) {
				// DOM 被销毁重建过，TCPlayer 已失去渲染目标 → dispose 重建
				console.warn('助播', item.userId, 'TCPlayer 绑定的 video 已丢失，重建播放器');
				try { existingPlayer.dispose(); } catch (e) {}
				delete this.players[item.userId];
				// 往下走重新初始化
			} else if (currentSrc === item.pullUrl) {
				// 同一个流地址 + video 还在：保持播放
				return;
			} else {
				// 流地址变化：只换地址继续播放
				console.log('助播', item.userId, '拉流地址变化，更新地址');
				this.playPlayerVideo(item.userId, item.pullUrl);
				return;
			}
		}
		
		if (!item.pullUrl) {
			console.warn('助播', item.userId, '没有拉流地址');
			return
		}

		try {
			const videoEl = document.createElement('video');
			videoEl.id = 'tc-' + playerId;
			videoEl.preload = 'auto';
			videoEl.style.width = '100%';
			videoEl.style.height = '100%';
			videoEl.style.objectFit = 'cover';
			videoEl.style.background = 'transparent';
			videoEl.setAttribute('playsinline', true);
			videoEl.setAttribute('webkit-playsinline', true);
			videoEl.setAttribute('x5-playsinline', true);
			videoContainer.appendChild(videoEl);
			
			console.log('创建视频元素:', videoEl.id, '拉流地址:', item.pullUrl);
			
			const player = TCPlayer('tc-' + playerId, {
				src: item.pullUrl,
				licenseUrl: this.licenseUrl,
				autoplay: true,
				controls: false,
				playsinline: true,
				allowFullScreen: false,
				playbackRate: [1],
				webrtcConfig: {
					connectRetryCount: 999999,
				},
				backgroundColor: 'transparent',
				errorDisplay: false,
				posterImage: true,
				poster: item.userInfo && item.userInfo.headPortrait,
				bigPlayButton: false,
				width: '100%',
				height: '100%'
			})
			
			console.log('TCPlayer初始化成功:', item.userId);
			
			const playerVideoElement = videoContainer.querySelector('video');
			if (playerVideoElement) {
				playerVideoElement.style.position = 'absolute';
				playerVideoElement.style.top = '0';
				playerVideoElement.style.left = '0';
				playerVideoElement.style.width = '100%';
				playerVideoElement.style.height = '100%';
				playerVideoElement.style.background = 'transparent';
				playerVideoElement.style.objectFit = 'cover';
			}
			
			player.muted(item.isPermitMicrophone !== 1)
			
			this.players[item.userId] = player
			
			player.on('play', () => {
				console.log('助播', item.userId, '开始播放');
			});
			
			player.on('playing', () => {
				console.log('助播', item.userId, '正在播放（有画面）');
			});
			
			player.on('loadedmetadata', () => {
				console.log('助播', item.userId, '元数据加载完成');
			});
			
			player.on('loadeddata', () => {
				console.log('助播', item.userId, '第一帧数据加载完成');
			});
			
			player.on('timeupdate', () => {
				// console.log('助播', item.userId, '播放时间更新');
			});
			
			player.on('webrtcevent', (e) => {
				const code = e.data && e.data.code;
				if (code === 1003) {
					console.log('助播', item.userId, 'WebRTC 有画面');
				} else if (code === 1005 || code === 1009) {
					console.log('助播', item.userId, 'WebRTC 无画面');
				}
			});
			
			player.on('error', (e) => {
				console.error('助播', item.userId, '播放错误:', e);
				this.handlePlayerError(item);
			});
			
			this.playPlayerVideo(item.userId, item.pullUrl);
		} catch (error) {
			console.error('初始化播放器失败:', item.userId, error)
		}
	},
	// 处理播放器错误，销毁后定时重试重新拉流
	handlePlayerError(item) {
		const userId = item.userId;
		// 避免重复重试
		if (this['_retrying_' + userId]) return;
		this['_retrying_' + userId] = true;
		
		// 销毁出错的播放器
		this.destroySinglePlayer(userId);
		
		// 启动重试，每5秒尝试重新拉流
		let retryCount = 0;
		const maxRetry = 60; // 最多重试5分钟
		const retryTimer = setInterval(async () => {
			retryCount++;
			if (retryCount > maxRetry) {
				clearInterval(retryTimer);
				this['_retrying_' + userId] = false;
				console.warn('助播', userId, '重连超过最大次数，停止重试');
				return;
			}
			
			try {
				// 重新获取直播间详情拿到最新的拉流地址
				const res = await getChatRoomDetails({ liveId: this.liveId });
				const userList = res.data.helpLiveUserList || [];
				const updatedItem = userList.find(u => u.userId == userId);
				
				if (updatedItem && updatedItem.pullUrl && updatedItem.cameraStatus !== 0) {
					clearInterval(retryTimer);
					this['_retrying_' + userId] = false;
					console.log('助播', userId, '重连中，第', retryCount, '次尝试，发现有效拉流地址');
					// 确保旧播放器已销毁
					this.destroySinglePlayer(userId);
					this.$nextTick(() => {
						setTimeout(() => {
							this.initPlayer(updatedItem);
						}, 500);
					});
				} else {
					console.log('助播', userId, '重连中，第', retryCount, '次尝试，暂无有效流');
				}
			} catch (err) {
				console.warn('助播', userId, '重连查询失败:', err);
			}
		}, 5000);
		
		// 保存timer引用以便组件销毁时清理
		if (!this._retryTimers) this._retryTimers = {};
		this._retryTimers[userId] = retryTimer;
	},
	// 销毁单个播放器
	destroySinglePlayer(userId) {
		// 清理可能存在的重连定时器
		if (this['_retrying_' + userId]) {
			this['_retrying_' + userId] = false;
		}
		if (this._retryTimers && this._retryTimers[userId]) {
			clearInterval(this._retryTimers[userId]);
			delete this._retryTimers[userId];
		}
		const player = this.players[userId];
		if (player) {
			try {
				player.pause();
				player.src('');
				player.dispose();
			} catch (error) {
				console.warn('销毁播放器失败:', userId, error);
			}
			delete this.players[userId];
		}
		// 清理DOM中残留的video元素
		const container = document.getElementById('player-' + userId);
		if (container) {
			container.innerHTML = '';
		}
	},
	playPlayerVideo(userId, videoUrl) {
		const player = this.players[userId];
		if (!player) {
			console.warn('播放器未就绪:', userId);
			return;
		}
		
		if (player.currentSrc && player.currentSrc() !== videoUrl) {
			player.src(videoUrl);
		}
		
		try {
			player.play();
			console.log('播放器播放成功:', userId);
		} catch (e) {
			console.warn('自动播放失败:', userId, e);
		}
	},
	//销毁所有播放器（不包括自己的推流器）
	destroyPlayers(){
		Object.keys(this.players).forEach(userId => {
			const player = this.players[userId]
			if (player) {
				try {
					player.pause()
					player.src('')
					player.dispose()
				} catch (error) {
					console.error('销毁播放器失败:', error)
				}
			}
		})
		this.players = {}
	},
	async toggleMicrophone(item) {
		if(!item.helpId) return;
		if(!this.isHost) return;
		const newStatus = item.isPermitMicrophone === 1 ? 0 : 1;
		const res = await updateHelpLiveUser({
			helpId: item.helpId,
			isPermitMicrophone: newStatus
		});
		this.$message.success(res.msg);
		item.isPermitMicrophone = newStatus;
		const player = this.players[item.userId];
		if (player) {
			player.muted(newStatus !== 1);
		}
	},
	//显示弹框
	showModel(){
		if(this.localData.isOpenHelp == 0){
			this.showInvite = true
		}
		if(this.localData.isOpenHelp == 1){
			this.showPanel = true
		}
	},
	//创建助播
	async handleGenerateKey(){
		const res = await createHelpLive(this.zbForm)
		this.$message.success(res.msg);
		this.showInvite = false
		this.getChatRoomDetails()
		if(this.isHost){
			this.getAppHelpLiveConfig()
		}
	},
	//获取助播配置
	async getAppHelpLiveConfig(){
		if(!this.isHost) return;
		const res = await getAppHelpLiveConfig({liveId:this.liveId})
		this.liveConfig = res.data
		console.log(this.liveConfig)
		// 赋值给controlForm
		if(this.liveConfig){
			this.controlForm.helpLiveConfigId = this.liveConfig.helpLiveConfigId
			this.controlForm.isPermitCamera = this.liveConfig.isPermitCamera
			this.controlForm.isPermitMicrophone = this.liveConfig.isPermitMicrophone
			this.controlForm.isPermitSpeech = this.liveConfig.isPermitSpeech
		}
	},
	//邀请助播
	async handleInvite(){
		this.showShareInvite = true;
		this.$nextTick(() => {
			this.generateQRCode();
		})
	},
	generateQRCode() {
		if (!this.liveConfig.shareUrl) return;
		const canvas = this.$refs.qrcodeCanvas;
		if (canvas) {
			QRCode.toCanvas(canvas, this.liveConfig.shareUrl, {
				width: 160,
				margin: 2,
				color: {
					dark: '#000000',
					light: '#ffffff'
				}
			}, (error) => {
				if (error) {
					console.error(error);
				}
			});
		}
	},
    async handleOpenList() {
	  const res = await getHelpUserList({liveId:this.liveId})
	  this.helpUserList = res.data
      if (res.data.length > 0) {
        this.showCohostList = true;
      }else{
		this.$message.warning(this.$t('all.zanweiyourenjiaruxietongzhibo')); 
	  }
    },
    handleSelect(index) {
      this.activeIndex = index;
      this.showCohostList = true;
      this.$emit('select', index);
    },
    async handleControl() {
      this.showPanel = false;
	  // 先获取最新配置
	  if(this.isHost){
		await this.getAppHelpLiveConfig();
	  }
	  setTimeout(v=>{
		this.showControlModal = true; 
	  },200)
    },
	
	//踢出选中主播
    async handleKick() {
      const res = await kickOutHelp({helpId:this.localData.helpLiveUserList[this.activeIndex].helpId})
	  this.$message.success(res.msg);
	  this.localData.helpLiveUserList.splice(this.activeIndex,1)
    },
    
    handleOpenLimit() {
      this.tempMaxCohost = this.maxCohost;
      this.showLimitPanel = !this.showLimitPanel;
    },
    handleSaveLimit() {
      this.maxCohost = this.tempMaxCohost;
	  this.zbForm.peopleNumber = this.maxCohost
      this.showLimitPanel = false;
    },
    handleCopyLink() {
      navigator.clipboard.writeText(this.liveConfig.shareUrl);
      this.$message.success(this.$t('all.fuzhichenggong'));
    },
    handleSaveQr() {
      const canvas = this.$refs.qrcodeCanvas;
      if (!canvas) {
        this.$message.info('二维码不存在');
        return;
      }
      const link = document.createElement('a');
      link.download = 'qrcode.png';
      link.href = canvas.toDataURL('image/png');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.$message.success('二维码保存成功');
    },
    handleCopyInviteLink() {
      navigator.clipboard.writeText(this.localData.shareUrl);
      this.$message.success(this.$t('all.fuzhichenggong'));
    },
    async handleManageCohost(item, index) {
	  const res = await getHelpUserInfo({helpId:item.helpId})
      this.managingCohost = res.data;
	  const sort = index + 1
	  this.managingCohost.sort = sort < 10?'0' + sort : sort
      this.showManagePanel = true;
    },
    async handleUpdatePerm(field) {
      // 先切换本地状态
      this.managingCohost[field] = this.managingCohost[field] === 1 ? 0 : 1;
      // 调用接口
      const res = await updateHelpLiveUser({
        helpId: this.managingCohost.helpId,
        [field]: this.managingCohost[field]
      });
      this.$message.success(res.msg);
      // 刷新列表
      await this.refreshHelpUserList();
    },
    async refreshHelpUserList() {
      const userRes = await getHelpUserList({ liveId: this.liveId });
      if (userRes.data && userRes.data.length) {
        this.helpUserList = userRes.data;
      }
      const roomRes = await getChatRoomDetails({ liveId: this.liveId });
      this.localData = roomRes.data;
      this.$nextTick(() => {
        // 增量同步，避免全量销毁重建造成画面闪烁
        this.syncPlayers();
      });
      if (this.managingCohost && this.managingCohost.helpId) {
        const updated = this.localData.helpLiveUserList.find(item => item.helpId === this.managingCohost.helpId);
        if (updated) {
          this.managingCohost = updated;
        }
      }
    },
    async handleSetMain() {
      const newStatus = this.managingCohost.isMainScreen === 1 ? 0 : 1;
      try {
        const res = await updateHelpLiveUser({
          helpId: this.managingCohost.helpId,
          isMainScreen: newStatus
        });
        this.$message.success(res.msg);
        this.managingCohost.isMainScreen = newStatus;
        this.showManagePanel = false;
		this.showCohostList = false
        await this.refreshHelpUserList();
        this.$emit('mainScreenChange', newStatus === 1 ? this.managingCohost : null);
      } catch (error) {
        console.error('设置主画面失败:', error);
      }
    },
    async handleKickCohost() {
      const res = await kickOutHelp({ helpId: this.managingCohost.helpId });
      this.$message.success(res.msg);
      this.showManagePanel = false;
      // 刷新列表
      await this.refreshHelpUserList();
    },
    async handleApplyControl() {
      const res = await updateHelpLiveConfig(this.controlForm);
      this.$message.success(res.msg);
	  this.getChatRoomDetails()
      this.showControlModal = false;
    },
    async handleJoinLive() {
	  console.log(this.helpKey,'helpKey')
	  if(this.helpKey){
		const res = await getHelpKeyInfo({liveId:this.liveId,helpKey:'sXsXcfWsSiGW4dgn'})
		this.helpKeyInfo = res.data
		this.showJoinLive = true;
		this.joinKey = '';  
	  }else{
		this.showJoinLive = true;  
	  }
	  
    },
    async handleSubmitJoin() {
      if(!this.helpKeyInfo.helpKey){
        this.$message.warning(this.$t('all.qingshuruzhubojinyao'));
        return;
      }
      try {
        const hasPermission = await this.checkMediaPermission();
        if (!hasPermission) {
          return;
        }
        const res = await joinHelpLive({helpKey:this.helpKeyInfo.helpKey})
        this.$message.success(res.msg);
        this.showJoinLive = false;
        await this.getChatRoomDetails();
        console.log('xietongzhibo: handleSubmitJoin success, data:', this.localData);
        console.log('xietongzhibo: isJoinedHelpLive:', this.isJoinedHelpLive);
        this.$emit('joinsuccess');
      } catch (error) {
        console.error('加入协同直播失败:', error);
      }
    },
	async handleExitHelp(){
	  const currentUserId = JSON.parse(this.$store.state.userId);
	  const helpInfo = this.localData.helpLiveUserList.find(item => item.userInfo && item.userInfo.userId === currentUserId);
	  if (!helpInfo) {
		console.error('找不到当前用户的助播信息');
		return;
	  }
	  const res = await exitHelp({helpId:helpInfo.helpId});
	  this.isAgentJoin = false;
	  this.$message.success(res.msg);
	  if (this.selfPusher) {
		try {
		  this.selfPusher.stopCamera();
		  this.selfPusher.stopMicrophone();
		  this.selfPusher.stopPush();
		  this.selfPusher.destroy();
		} catch (error) {
		  console.error('销毁推流失败:', error);
		}
		this.selfPusher = null;
	  }
	  await this.getChatRoomDetails();
	},
	async checkMediaPermission() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.$message.warning(this.$t('all.browserbu支持'));
        return false;
      }
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ 
          video: true, 
          audio: true 
        });
        stream.getTracks().forEach(track => track.stop());
        return true;
      } catch (error) {
        console.error('媒体权限获取失败:', error);
        if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
          this.$message.warning(this.$t('all.qingkaiqi'));
        } else if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') {
          this.$message.warning(this.$t('all.meiyoushebei'));
        } else if (error.name === 'NotReadableError' || error.name === 'TrackStartError') {
          this.$message.warning(this.$t('all.shebeibeizhan'));
        } else {
          this.$message.warning(this.$t('all.quxianchengong'));
        }
        return false;
      }
    },
  }
};
</script>

<style scoped lang="scss">
.xtzb-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  // width: 110px;
  flex-shrink: 0;
  position: relative;
  padding: 30px 0px 30px 0px;
  box-sizing: border-box;
}

.xtzb-list {
  
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.xtzb-list::-webkit-scrollbar { display: none; }

.xtzb-item {
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  flex-shrink: 0;
  position: relative;
  height: 100px;
  width: 100px;
  margin-right: 10px;
}

.xtzb-zhubo {
  margin-top: auto;
  flex-shrink: 0;
}

.xtzb-item:first-child {
  margin-top: auto;
}

.xtzb-item-active {
  // border-color: #369AFF;
}

.xtzb-item-img {
  width: 100%;
  height: 100px;
  object-fit: cover;
  display: block;
}
.xtzb-item-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #000;
  z-index: 1;
}
.xtzb-item-video{
	width: 100%;
	height: 100%;
	object-fit: cover;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 2;
}
.xtzb-item-player{
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 2;
}
// 封面在播放器后面（z-index:1），播放器背景透明，有画面盖封面、无画面透封面
.xtzb-item-player-cover {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1;
	pointer-events: none;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: transparent;
}
.xtzb-item-player-cover img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: inherit;
}
// TCPlayer video 背景透明：否则没有画面时显示黑色盖住封面
.xtzb-item-player video {
	background-color: transparent !important;
}
.xtzb-item-player .video-js,
.xtzb-item-player .tcp-skin {
	background-color: transparent !important;
}
.xtzb-item-pusher{
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 2;
	overflow: hidden;
}
.xtzb-item-vioce{
	width: 16px;
	height: 16px;
	position: absolute;
	top: 6px;
	right: 6px;
	cursor: pointer;
	z-index: 10;
}
.xtzb-item-cover{
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 1;
}
.xtzb-item-cover-box{
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
.xtzb-item-cover-img{
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
}
.xtzb-item-user{
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  z-index: 10;
}
.xtzb-item-user-sort{
	width: 14px;
	height: 14px;
	background: rgba(0,0,0,0.4);
	border-radius: 16px 16px 16px 16px;
	font-family: MiSans, MiSans;
	font-weight: 400;
	font-size: 9px;
	color: #FFFFFF;
	line-height: 14px;
	text-align: center;
}
.xtzb-item-user-name{
	font-family: MiSans, MiSans;
	font-weight: 400;
	font-size: 12px;
	color: #FFFFFF;
	margin-left: 4px;
}
.xtzb-item-video {
  width: 100%;
  height: 100px;
  object-fit: cover;
  background: #000;
}

.xtzb-btn {
  margin-top: 8px;
  margin-right: 10px;
  padding: 8px 0;
  background: rgba(54, 154, 255, 0.2);
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  flex-shrink: 0;
  width: 100px;
}

.xtzb-btn-text {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 11px;
  color: #369AFF;
}

/* 管理面板 */
.xtzb-panel {
  position: absolute;
  right: calc(100% + 10px);
  bottom: 30px;
  width: 330px;
  background: #252632;
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4);
  z-index: 100;
}

.xtzb-panel-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.xtzb-panel-title {
  font-family: MiSans, MiSans;
  font-weight: 600;
  font-size: 16px;
  color: #FFFFFF;
}

.xtzb-panel-count {
  padding: 2px 10px;
  background: rgba(0, 214, 143, 0.2);
  border-radius: 10px;
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 12px;
  color: #00D68F;
}

.xtzb-panel-users {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  margin-bottom: 16px;
  cursor: pointer;
}

.xtzb-panel-empty {
  grid-column: 1 / -1;
  text-align: center;
  padding: 30px 0;
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
}

.xtzb-panel-user {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 10px;
  border-radius: 10px;
  border: 2px solid rgba(255,255,255,0.2);
}
.xtzb-panel-user-active{
	border: 2px solid #369AFF;
}
.xtzb-panel-user-img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
}

.xtzb-panel-user-name {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 11px;
  color: #FFFFFF;
}

.xtzb-panel-user-status {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 10px;
  color: #019DFF;
}

// .xtzb-status-live {
//   background: rgba(251, 72, 90, 0.2);
//   color: #FB485A;
// }

// .xtzb-status-wait {
//   background: rgba(54, 154, 255, 0.2);
//   color: #369AFF;
// }

.xtzb-panel-actions {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 12px;
}

.xtzb-panel-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}

.xtzb-panel-action-btn {
  flex: 1;
  height: 36px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 13px;
  color: #FFFFFF;
  cursor: pointer;
}
.xtzb-panel-action-btn:hover {
  background: rgba(255, 255, 255, 0.12);
}

.xtzb-panel-kick-btn {
  width: 100%;
  height: 40px;
  background: linear-gradient(90deg, #369AFF 0%, #8200CB 100%);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  cursor: pointer;
}
.xtzb-panel-kick-btn:hover {
  opacity: 0.9;
}

/* 邀请助播弹框 */
.xtzb-invite-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
}

.xtzb-invite-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  background: #252632;
  border-radius: 20px;
  padding: 30px;
  z-index: 999;
}

.xtzb-invite-title {
  font-family: MiSans, MiSans;
  font-weight: 600;
  font-size: 20px;
  color: #FFFFFF;
  margin-bottom: 20px;
}

.xtzb-invite-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}

.xtzb-invite-item-label {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
}

.xtzb-invite-item-right {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.xtzb-invite-item-value {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
}

.xtzb-invite-item-status {
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 13px;
  color: #0A99F3;
}

.xtzb-invite-item-arrow {
  width: 14px;
  height: 14px;
}

.xtzb-invite-section-title {
  font-family: MiSans, MiSans;
  font-weight: 600;
  font-size: 15px;
  color: #FFFFFF;
  margin: 16px 0 10px 0;
}

.xtzb-invite-btn {
  margin-top: 20px;
  width: 100%;
  height: 50px;
  background: linear-gradient(90deg, #369AFF 0%, #8200CB 100%);
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  cursor: pointer;
}
.xtzb-invite-btn:hover {
  opacity: 0.9;
}

/* 助播人数上限面板 */
.xtzb-limit-panel {
  position: absolute;
  top: 0;
  left: calc(100% + 10px);
  width: 220px;
  background: #252632;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4);
  z-index: 10000;
}

.xtzb-limit-title {
  font-family: MiSans, MiSans;
  font-weight: 600;
  font-size: 14px;
  color: #FFFFFF;
  margin-bottom: 12px;
}

.xtzb-limit-options {
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-bottom: 16px;
}

.xtzb-limit-option {
  flex: 1;
  height: 32px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
  cursor: pointer;
}

.xtzb-limit-option-active {
  flex: 1;
  height: 32px;
  background: #369AFF;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 12px;
  color: #FFFFFF;
  cursor: pointer;
}

.xtzb-limit-info {
  background: rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
}

.xtzb-limit-info-title {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 6px;
}

.xtzb-limit-info-num {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: #019DFF;
  margin-bottom: 6px;
}

.xtzb-limit-info-big {
  font-weight: 700;
  font-size: 28px;
  color: #019DFF;
}

.xtzb-limit-info-desc {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
}

.xtzb-limit-save {
  width: 100%;
  height: 36px;
  background: linear-gradient( 81deg, #369AFF 0%, #8200CB 88.07%);
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 13px;
  color: #FFFFFF;
  cursor: pointer;
}
.xtzb-limit-save:hover {
  background: rgba(255, 255, 255, 0.12);
}

/* 分享邀请弹框 */
.xtzb-share-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 480px;
  background: #252632;
  border-radius: 20px;
  padding: 30px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.xtzb-share-title {
  font-family: MiSans, MiSans;
  font-weight: 600;
  font-size: 20px;
  color: #FFFFFF;
  margin-bottom: 20px;
  align-self: flex-start;
}

.xtzb-share-qrcode {
  margin-bottom: 20px;
}

.xtzb-share-qrcode canvas {
  width: 160px;
  height: 160px;
}

.xtzb-share-item {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
}

.xtzb-share-item-label {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  flex-shrink: 0;
}

.xtzb-share-item-value {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 13px;
  color: #369AFF;
  word-break: break-all;
  margin-left: 60px;
  text-align: right;
}

.xtzb-share-subtitle {
  font-family: MiSans, MiSans;
  font-weight: 600;
  font-size: 15px;
  color: #FFFFFF;
  margin: 16px 0 12px 0;
  align-self: flex-start;
}

.xtzb-share-actions {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 12px;
}

.xtzb-share-action-btn {
  flex: 1;
  height: 42px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 21px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  cursor: pointer;
}

.xtzb-share-action-gradient {
  background: linear-gradient(90deg, #369AFF 0%, #8200CB 100%);
}

.xtzb-share-action-btn:hover {
  opacity: 0.9;
}

.xtzb-share-big-btn {
  width: 80%;
  height: 50px;
  background: linear-gradient(90deg, #369AFF 0%, #8200CB 100%);
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  cursor: pointer;
}
.xtzb-share-big-btn:hover {
  opacity: 0.9;
}

/* 助播列表弹框 */
.xtzb-cohost-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  height: 400px;
  max-height: 80vh;
  background: #252632;
  border-radius: 20px;
  padding: 30px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
}

.xtzb-cohost-title {
  font-family: MiSans, MiSans;
  font-weight: 600;
  font-size: 20px;
  color: #FFFFFF;
  margin-bottom: 16px;
}

.xtzb-cohost-list {
  flex: 1;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.xtzb-cohost-list::-webkit-scrollbar { display: none; }

.xtzb-cohost-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  margin-bottom: 10px;
  gap: 12px;
}

.xtzb-cohost-item-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.xtzb-cohost-item-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.xtzb-cohost-item-name {
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
}
.xtzb-cohost-item-box{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.xtzb-cohost-item-status {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 12px;
  margin-top: 2px;
}

.xtzb-cohost-status-live {
  color: #0A99F3;
}

.xtzb-cohost-status-wait {
  color: rgba(255, 255, 255, 0.5);
}

.xtzb-cohost-item-manage {
  padding: 5px 14px;
  background: linear-gradient(90deg, #369AFF 0%, #8200CB 100%);
  border-radius: 14px;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
  cursor: pointer;
  flex-shrink: 0;
}
.xtzb-cohost-item-manage:hover {
  opacity: 0.9;
}

/* 管理面板 */
.xtzb-manage-panel {
  position: absolute;
  top: 0;
  left: calc(100% + 10px);
  width: 220px;
  background: #252632;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.xtzb-manage-close {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 18px;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.2s;
}

.xtzb-manage-close:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.xtzb-manage-perm-status {
  color: rgba(255, 255, 255, 0.5);
}

.xtzb-manage-perm-status-on {
  color: #369AFF;
}

.xtzb-manage-user {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;
  gap: 10px;
}

.xtzb-manage-user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.xtzb-manage-user-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.xtzb-manage-user-name {
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
}

.xtzb-manage-user-id {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  margin-top: 2px;
}

.xtzb-manage-user-tag {
  padding: 3px 10px;
  background: rgba(107,234,169,0.2);
  border-radius: 10px;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 11px;
  color: #6BEAA9;
  flex-shrink: 0;
}

.xtzb-manage-section-title {
  font-family: MiSans, MiSans;
  font-weight: 600;
  font-size: 13px;
  color: #FFFFFF;
  width: 100%;
  margin-bottom: 10px;
}

.xtzb-manage-perm-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 14px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 10px;
  margin-bottom: 8px;
  box-sizing: border-box;
}

.xtzb-manage-perm-label {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 13px;
  color: #FFFFFF;
}

.xtzb-manage-perm-right {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.xtzb-manage-perm-status {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 12px;
  color: #0A99F3;
}

.xtzb-manage-perm-arrow {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
}

.xtzb-manage-btn {
  width: 100%;
  height: 36px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 13px;
  color: #FFFFFF;
  cursor: pointer;
  margin-top: 8px;
}
.xtzb-manage-btn:hover {
  background: rgba(255, 255, 255, 0.12);
}

.xtzb-manage-kick-btn {
  width: 100%;
  height: 36px;
  background: #FF365D;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 13px;
  color: #ffffff;
  cursor: pointer;
  margin-top: 8px;
}

.xtzb-manage-tip {
	font-family: MiSans, MiSans;
	font-weight: 400;
	font-size: 11px;
	color: rgba(255, 255, 255, 0.5);
	margin-top: 8px;
}

/* 统一控麦弹框 */
.xtzb-control-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  background: #252632;
  border-radius: 20px;
  padding: 30px;
  z-index: 9999;
}

.xtzb-control-title {
  font-family: MiSans, MiSans;
  font-weight: 600;
  font-size: 20px;
  color: #FFFFFF;
  margin-bottom: 20px;
}

.xtzb-control-section {
  font-family: MiSans, MiSans;
  font-weight: 600;
  font-size: 15px;
  color: #FFFFFF;
  margin-bottom: 12px;
}

.xtzb-control-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}

.xtzb-control-item-label {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
}

.xtzb-control-item-right {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
}

.xtzb-control-status-on {
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 13px;
  color: #0A99F3;
}

.xtzb-control-status-off {
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
}

.xtzb-control-item-arrow {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

.xtzb-control-actions {
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-bottom: 12px;
}

.xtzb-control-action-btn {
  flex: 1;
  height: 42px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 21px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  cursor: pointer;
}

.xtzb-control-action-gradient {
  background: linear-gradient(90deg, #369AFF 0%, #8200CB 100%);
}

.xtzb-control-action-btn:hover {
  opacity: 0.9;
}

.xtzb-control-apply {
  margin-top: 8px;
  width: 100%;
  height: 50px;
  background: linear-gradient(90deg, #369AFF 0%, #8200CB 100%);
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  cursor: pointer;
}
.xtzb-control-apply:hover {
  opacity: 0.9;
}

/* 加入协同直播弹框 */
.xtzb-join-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  background: #252632;
  border-radius: 20px;
  padding: 30px;
  z-index: 999;
}

.xtzb-join-title {
  font-family: MiSans, MiSans;
  font-weight: 600;
  font-size: 20px;
  color: #FFFFFF;
  text-align: center;
  margin-bottom: 24px;
}

.xtzb-join-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: rgba(255,255,255,0.07);
  border-radius: 12px 12px 12px 12px;
  border: 2px dotted rgba(10,153,243,0.33);
  height: 48px;
  padding: 0px 16px;
  gap: 8px;
  margin-bottom: 16px;
}

.xtzb-join-item-label {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  flex-shrink: 0;
}

.xtzb-join-item-value {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
}

.xtzb-join-input {
  height: 48px;
  background: none;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  box-sizing: border-box;
  outline: none;
  border: none;
  text-align: right;
}

.xtzb-join-input::placeholder {
  color: rgba(255, 255, 255, 0.3);
}

.xtzb-join-input:focus {
  border-color: #369AFF;
}

.xtzb-join-btn {
  margin-top: 16px;
  width: 100%;
  height: 50px;
  background: linear-gradient(90deg, #369AFF 0%, #8200CB 100%);
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  cursor: pointer;
}

.xtzb-join-btn:hover {
  opacity: 0.9;
}
</style>
<style>
	.video-js{
		background: transparent !important;
	}
	.tcp-skin {
		background: transparent !important;
	}
	.tcp-skin video,
	.video-js video {
		background: transparent !important;
	}
	.vjs-tech {
		background: transparent !important;
	}
	/* TCPlayer 官方封面：填满容器 */
	.vjs-poster {
		position: absolute !important;
		top: 0 !important;
		left: 0 !important;
		width: 100% !important;
		height: 100% !important;
		background-size: cover !important;
		background-position: center !important;
		background-repeat: no-repeat !important;
	}
	/* 隐藏 loading spinner */
	.tcp-skin .tcp-loading-spinner {
		display: none !important;
	}
	.tcp-skin.vjs-seeking .tcp-loading-spinner,
	.tcp-skin.vjs-waiting .tcp-loading-spinner {
		display: none !important;
	}
</style>



// WEBPACK FOOTER //
// xietongzhibo.vue?a35e84ac